import moment from "moment"

export default function timeCreated(dateCreated: number) {
  const now = moment()
  const beginning = moment(new Date(dateCreated * 1000))
  moment.updateLocale("en", {
    relativeTime: {
      s: "sec",
      m: "now",
      mm: "%dm",
      h: "%dh",
      hh: "%dh",
      d: "%dd",
      dd: "%dd",
      M: "%dM",
      MM: "%dM"
    }
  })
  const timeSinceCreated = beginning.from(now, true)

  return timeSinceCreated
}
